import {Box, Grid} from '@mui/material';
import {string, arrayOf, func, bool} from 'prop-types';

import useProfile from '../../../hooks/providers/useProfile';
import {userShape} from '../../../proptypes-shapes';
import TitleWithTooltip from '../../project/TitleWithTooltip';
import UsersChipsList from '../../users/UsersChipsList';

const WorkspaceOrReportUsersList = ({isWorkspaceUsersList, readonly = false, title, titleTooltip, users, onChipDelete, isSubmitting}) => {
  const {profile} = useProfile();

  const isOnlyOwner = (users || []).length === 1 && users[0]?.user_id?.toLowerCase() === profile.id;
  const isLastWorkspaceUser = isWorkspaceUsersList && isOnlyOwner;

  if (users.length === 0) return null;

  return (
    <Box mb={2}>
      <Grid container alignItems="center" mb={2}>
        <TitleWithTooltip title={title} tooltip={titleTooltip} />
      </Grid>

      <UsersChipsList users={users} onDelete={readonly || isLastWorkspaceUser ? undefined : onChipDelete} isDisabled={isSubmitting || isLastWorkspaceUser || readonly} showDeleteIcon={!readonly} />
    </Box>
  );
};

WorkspaceOrReportUsersList.propTypes = {
  title: string.isRequired,
  titleTooltip: string.isRequired,
  users: arrayOf(userShape).isRequired,
  onChipDelete: func,
  isSubmitting: bool.isRequired,
  // eslint-disable-next-line react/boolean-prop-naming
  readonly: bool,
  isWorkspaceUsersList: bool.isRequired
};

export default WorkspaceOrReportUsersList;
